import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgxMonacoEditorConfig, provideMonacoEditor } from "ngx-monaco-editor-v2";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { PosthogService } from "./shared/services/monitoring/posthog.service";
import { GlobalErrorHandlerService } from "./shared/services/monitoring/global-error-handler.service";

const monacoConfig: NgxMonacoEditorConfig = {
	baseUrl: "/monaco/vs", // must match your angular.json asset path
	defaultOptions: { theme: "vs-dark" }, // optional defaults
	onMonacoLoad: () => {
		console.log("🎉 Monaco is ready!", (window as any).monaco);
	},
};
export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: { darkModeSelector: ".p-dark" },
			},
		}),
		provideRouter(routes),
		provideMonacoEditor(monacoConfig),
		PosthogService,
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandlerService,
		},
	],
};
